import { useRef } from "react";
import useElementDims from "./useElementDims";

const DEFAULT_COLORS = [
  "darkblue",
  "skyblue",
  "orange",
]

const DOT_DIM = 8;

export function getDefaultColorOrder(){
  return [...DEFAULT_COLORS];
}

function BarGroup({ values, maxVal, type }){


  if( type === "points" ){

    return (
      <div style={{
        paddingLeft:2,
        paddingRight:2,
      }} class="rel full-width full-height">


        {values.map( (value,ii) => {

          let height = (Math.round(value/maxVal * 100))+'%'
          return (
            <>
              <div style={{
                position:"absolute",
                bottom:height,
                left:'50%',
                transform:'translate(-50%,50%)',
                background:DEFAULT_COLORS[ii],
                width:DOT_DIM,
                height:DOT_DIM,
                borderRadius:10,
                //border:'1px solid red'
              }}/>
            </>
          )
        })}

        
      </div>
    )


  }

  return (
    <div style={{
      //outline:'1px solid red',
      paddingLeft:2,
      paddingRight:2,
      }} class="sg-row full-height">
      

      {values.map( (value,ii) => {

        let height = (Math.round(value/maxVal * 100))+'%'
        return (
        <div class="full-height flex-expand sg-col rel ">

          <div class="flex-expand"/>

          <div class="rel" style={{
            background:DEFAULT_COLORS[ii],
            outline:'1px solid white',
            width:'100%',
            height,
          }}>

            <div style={{
              position:'absolute',
              //outline:'0.5px solid white',
              borderRight:'1px solid white',
              borderBottom:'1px solid white',
              height:'100%',
              width:'100%'
            }}/>

            
          </div>

        </div>
      )
    })}

      <div style={{
        position:'absolute',
        right:0,
        height:5,
        width:2,
        bottom:0,
        background:'#ccc'
      }}/>

    </div>
  )

}


function BottomLabel({ label, width }) {
  return <div style={{
    textAlign: 'right',
    verticalAlign: 'middle',
    //transform:'translate(-100%,100%) rotate(-45deg)',
    width,
    position: 'relative',
    paddingTop: '2px'
  }}>
    <div style={{
      position: 'absolute',
      textAlign: 'right',
      right: '50%',
      //top: '50%',
      transformOrigin: 'top right',
      transform: 'rotate(-45deg) translateY(-50%)',
    }}>{label}</div>
  </div>;
}

export default function Barplot({values, labels, outerProps, type}){


  let nVals = Math.max(...values.map(x => x.length))
  let maxVal = Math.max(...Object.values(values).flat());
  let iterator = Array(nVals).fill(null);
  const plotContainerRef = useRef(null);
  const plotDims = useElementDims(plotContainerRef);
  let barWidth = null;
  if (plotDims != null) {
    barWidth = plotDims.width / labels.length;
  }

  return (

    <div 
      ref={plotContainerRef}
      class="sg-row flex-expand"
      style={{
        //width:100,
        height:100,
        position:'relative',
        borderBottom:'1px solid #ccc',
        minWidth: 0,
      }}
      {...outerProps}>

      {iterator.map( (_null,iiLane) => {
        //each column from the row
        let valueSet = values.map(vv => vv[iiLane]).filter(x => !isNaN(x));
        return (
          <div class="rel flex-expand">
            <BarGroup type={type} values={valueSet} maxVal={maxVal}/>
            {labels && <BottomLabel label={labels[iiLane]} width={barWidth} />}
          </div>
        )
      })}
    </div>
  )
      }
